module.exports = __webpack_public_path__ + "static/img/16.75151a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/16.png
// module id = mIvx
// module chunks = 1